// AUTO GENERATED FILE - DO NOT EDIT

const classNames = {
  'about-text': 'about-text',
  'button': 'button',
  'careers-list': 'careers-list',
  'clickable': 'clickable',
  'cp-stats-leetcode': 'cp-stats-leetcode',
  'cp-stats-leetcode-summary': 'cp-stats-leetcode-summary',
  'cp-stats-leetcode-summary-content': 'cp-stats-leetcode-summary-content',
  'dark': 'dark',
  'domain-canvas': 'domain-canvas',
  'domain-circle': 'domain-circle',
  'domains': 'domains',
  'education-card': 'education-card',
  'education-card-content': 'education-card-content',
  'education-card-degree': 'education-card-degree',
  'education-card-grade': 'education-card-grade',
  'education-card-icon': 'education-card-icon',
  'education-card-icon-container': 'education-card-icon-container',
  'education-card-separator': 'education-card-separator',
  'education-card-title': 'education-card-title',
  'education-cards': 'education-cards',
  'education-history': 'education-history',
  'education-history-title': 'education-history-title',
  'error-code': 'error-code',
  'error-container': 'error-container',
  'error-content': 'error-content',
  'error-heading': 'error-heading',
  'error-image': 'error-image',
  'error-message': 'error-message',
  'error-meta': 'error-meta',
  'experience': 'experience',
  'experience-column': 'experience-column',
  'experience-company': 'experience-company',
  'experience-contribution': 'experience-contribution',
  'experience-contributions': 'experience-contributions',
  'experience-grid': 'experience-grid',
  'experience-icon': 'experience-icon',
  'experience-role': 'experience-role',
  'experience-separator': 'experience-separator',
  'experience-separator-icon': 'experience-separator-icon',
  'experience-shine': 'experience-shine',
  'fly-pulse': 'fly-pulse',
  'footer': 'footer',
  'footer-content': 'footer-content',
  'heading-large': 'heading-large',
  'heading-max': 'heading-max',
  'heading-medium': 'heading-medium',
  'heading-small': 'heading-small',
  'hero': 'hero',
  'hero-background': 'hero-background',
  'hero-brand': 'hero-brand',
  'hero-content': 'hero-content',
  'hero-image': 'hero-image',
  'hero-subtitle': 'hero-subtitle',
  'infolet': 'infolet',
  'infolet-content': 'infolet-content',
  'infolet-icon': 'infolet-icon',
  'infolet-icon-container': 'infolet-icon-container',
  'input': 'input',
  'input-container': 'input-container',
  'jiggle': 'jiggle',
  'latest': 'latest',
  'latest-linklets': 'latest-linklets',
  'limit-width': 'limit-width',
  'line-break': 'line-break',
  'line-graph': 'line-graph',
  'line-graph-point': 'line-graph-point',
  'line-graph-point-tooltip': 'line-graph-point-tooltip',
  'line-graph-points': 'line-graph-points',
  'linklet': 'linklet',
  'linklet-content': 'linklet-content',
  'linklet-hover': 'linklet-hover',
  'linklet-hover-icon': 'linklet-hover-icon',
  'linklet-hover-url': 'linklet-hover-url',
  'linklet-icon': 'linklet-icon',
  'linklet-icon-container': 'linklet-icon-container',
  'linklet-ref': 'linklet-ref',
  'linklet-ref-icon': 'linklet-ref-icon',
  'linklet-url': 'linklet-url',
  'menu': 'menu',
  'menu-bottom-left': 'menu-bottom-left',
  'menu-bottom-right': 'menu-bottom-right',
  'menu-brand': 'menu-brand',
  'menu-brand-container': 'menu-brand-container',
  'menu-brand-image': 'menu-brand-image',
  'menu-button': 'menu-button',
  'menu-container': 'menu-container',
  'menu-top-left': 'menu-top-left',
  'menu-top-right': 'menu-top-right',
  'no-scrollpop': 'no-scrollpop',
  'node-bg': 'node-bg',
  'node-bg-node': 'node-bg-node',
  'open-source-card': 'open-source-card',
  'open-source-card-actions': 'open-source-card-actions',
  'open-source-card-content': 'open-source-card-content',
  'open-source-card-icon': 'open-source-card-icon',
  'open-source-card-info': 'open-source-card-info',
  'open-source-card-meta': 'open-source-card-meta',
  'open-source-card-mine': 'open-source-card-mine',
  'open-source-card-mine-container': 'open-source-card-mine-container',
  'open-source-card-repo': 'open-source-card-repo',
  'open-source-card-repo-text': 'open-source-card-repo-text',
  'open-source-card-title': 'open-source-card-title',
  'open-source-list': 'open-source-list',
  'parallax': 'parallax',
  'project-card': 'project-card',
  'project-card-actions': 'project-card-actions',
  'project-card-content': 'project-card-content',
  'project-card-description': 'project-card-description',
  'project-card-icon': 'project-card-icon',
  'project-card-info': 'project-card-info',
  'project-card-meta': 'project-card-meta',
  'project-card-mine': 'project-card-mine',
  'project-card-mine-container': 'project-card-mine-container',
  'project-card-repo': 'project-card-repo',
  'project-card-repo-text': 'project-card-repo-text',
  'project-card-title': 'project-card-title',
  'project-list': 'project-list',
  'projects-heading': 'projects-heading',
  'projects-search': 'projects-search',
  'projects-view': 'projects-view',
  'scrollpop': 'scrollpop',
  'section': 'section',
  'section-content': 'section-content',
  'social-link': 'social-link',
  'social-link-hover': 'social-link-hover',
  'social-link-hover-icon': 'social-link-hover-icon',
  'social-link-hover-url': 'social-link-hover-url',
  'social-link-icon': 'social-link-icon',
  'social-link-icon-container': 'social-link-icon-container',
  'social-link-title': 'social-link-title',
  'socials-linklets': 'socials-linklets',
  'socials-rows': 'socials-rows',
  'text': 'text',
  'textlet': 'textlet',
  'textlet-content': 'textlet-content',
  'textlet-icon': 'textlet-icon',
  'textlet-title': 'textlet-title',
  'theme-bubble': 'theme-bubble'
} as const;

export type ClassName = (keyof typeof classNames);
export type PossibleClassName = ClassName | false | null | undefined;
export function useClasses(...args: PossibleClassName[]): string {
  const validClass = (arg: PossibleClassName) => !!(arg && arg in classNames);
  const validClasses = args.filter(validClass) as ClassName[];

  return validClasses.map(arg => classNames[arg]).join(' ');
}

